/* eslint-disable */

import dc from 'dc';
import legend from 'd3-svg-legend';
import _ from 'lodash';
var crossfilter = dc.crossfilter;

const WDAY_LABELS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

const HEATMAP_DEFAULT = {
  selector: {
    compositeGroup: {
      container: ' .heatmap-block'
    },

    heatmap: {
      container: ' .heatmap',
    },

    barchartDays: {
      container: ' .barchart-days',
      svg: ' .barchart-days svg',
      chartBody: ' .barchart-days .chart-body'
    },

    barchartHours: {
      container: ' .barchart-hours',
      svg: ' .barchart-hours svg',
      chartBody: ' .barchart-hours .chart-body'
    },

    legendHeatmap: {
      container: ' .legend--heatmap',
      svg: ' .legend--heatmap svg',
      labels: ' .legend--heatmap .legendCells .label'
    }
  },

  heatmap: {width: 780, height: 240},
  hours: {width: 775, height: 110},
  days: {width: 276, height: 160},

  colorScale: {
    heatmap: {
      range: ['lightgrey', '#ccebc5', '#a8ddb5', '#7bccc4', '#4eb3d3', '#2b8cbe', '#0868ac', '#084081', '#063059', '#1C2B35']
    }
  }
}

// Heatmap Chart JS
//
var Heatmap = function(options) {
  this.WDAY_LABELS = WDAY_LABELS;
  this.default = HEATMAP_DEFAULT;

  this.options = options || {};
};

Heatmap.prototype.fillHoursDays = function(dataset) {
  var hasMissingDayHours = false;

  var newDataset = _.clone(dataset);
  var hasAllDays = _.uniq(dataset.map((d) => {return d.day})).length == 7;
  var hasAllHours = _.uniq(dataset.map((d) => {return d.hour})).length == 24;

  if (!hasAllDays || !hasAllHours) {
    hasMissingDayHours = true;

    for (var i = 0; i <= 23; i++) {
      for (var j = 0; j <= 6; j++) {

        var overwriteSource = _.clone(newDataset[0]);
        var overwriteExtra = _.merge(overwriteSource, {
            day: j,
            hour: i,
            value: 0,
            delivered: 0
          })
        newDataset.push(overwriteExtra)
      }
    }
  }

  return {hasMissingDayHours: hasMissingDayHours, newDataset: newDataset};
}

Heatmap.prototype.getDimensions = function (crossfilter) {
  var _self = this;
  var ndx = crossfilter ? crossfilter : _self.ndx;

  return {
    day_hour: ndx.dimension((d) => { return [+d.hour, +d.day]; }),
    day: ndx.dimension((d) => { return +d.day; }),
    hour: ndx.dimension((d) => { return +d.hour; }),
  };
};

Heatmap.prototype.getDayHourGroup = function(dimensions) {
  return dimensions.day_hour.group().reduce(
      /* callback for when data is added to the current filter results */
      function (p, v) {
          ++p.count;
          ++p.impTotal;

          p.impCount += v.value;

          p.percentageGain = p.impTotal ? (p.impCount / p.impTotal) : 0;
          return p;
      },
      /* callback for when data is removed from the current filter results */
      function (p, v) {
          --p.count;
          ++p.impTotal;

          p.impCount -= v.value;
          p.percentageGain = p.impTotal ? (p.impCount / p.impTotal) : 0;
          return p;
      },
      /* initialize p */
      function () {
        return {count: 0, impCount: 0, impTotal: 0, percentageGain: 0};
      }
  );
};

Heatmap.prototype.getDayGroup = function(dimensions) {
  return dimensions.day.group().reduceSum((d) => { return d.value; });
};

Heatmap.prototype.getHourGroup = function(dimensions) {
  return dimensions.hour.group().reduceSum((d) => { return d.value; })
};

Heatmap.prototype.snapToZero = function(source_group) {
  return {
    all:function () {
      return source_group.all().map(function(d) {
        return {key: d.key,
          value: (Math.abs(d.value)<1e-6) ? 0 : d.value};
        });
    }
  };
}

Heatmap.prototype.getDimensionGroups = function(dimensions) {
  var _self = this;

  var dayGroupWithZeroSnap = _self.snapToZero(_self.getDayGroup(dimensions));
  var hourGroupWithZeroSnap = _self.snapToZero(_self.getHourGroup(dimensions));

  return {
    day_hour: _self.getDayHourGroup(dimensions),
    day: dayGroupWithZeroSnap,
    hour: hourGroupWithZeroSnap
  }
};

Heatmap.prototype.getHeatmapKeyAccessor = function(d) { return +d.key[0]; }
Heatmap.prototype.getHeatmapValueAccessor = function (d) { return +d.key[1]; }
Heatmap.prototype.getHeatmapTitle = function(d) {
  return "  Visits:   " + Number(d.value.percentageGain).toFixed(2) + "%";
};

Heatmap.prototype.getBarchartDayTitle = function(d) {
  return "  Visits:   " + Number(d.value).toFixed(2) + "%";
};

Heatmap.prototype.getBarchartHourTitle = function(d) {
  return "  Visits:   " + Number(d.value).toFixed(2) + "%";
};

Heatmap.prototype.getLegendTitle = function(d) {
  var percentLabel = d3.format(".2%")(Number(d)/100);
  return d == 0 ? percentLabel : "< " + percentLabel ;
};

// Set the color domain using the 2 dimensions values of the heatmap
Heatmap.prototype.setColorDomain = function(dimensionGroupsDayHour) {
  var _self = this;

  var heatmapMaxYX = {}
  dimensionGroupsDayHour.all().forEach(function(i) {
    heatmapMaxYX["y." + i.key[1]] = heatmapMaxYX["y." + i.key[0]] || 0
    heatmapMaxYX["x." + i.key[0]] = heatmapMaxYX["x." + i.key[0]] || 0
    if (heatmapMaxYX["x." + i.key[0]] < parseFloat(i.value.impCount))
      heatmapMaxYX["x." + i.key[0]] = parseFloat(i.value.impCount)

    if (heatmapMaxYX["y." + i.key[1]] < parseFloat(i.value.impCount))
      heatmapMaxYX["y." + i.key[1]] = parseFloat(i.value.impCount)
  });

  var maxDayHour = Object.values(heatmapMaxYX).reduce((max, i) => {
    return max < i ? i : max;
  }, 0);

  var colorDomain = new Array(0,1,2,3,4,5,6,7,8,9).map((i) => {
    return (maxDayHour / 10) * (i==0 ? 0 : i+1);
  });

  _self.scaleRange.minGain = colorDomain[0];
  _self.scaleRange.maxGain = colorDomain[colorDomain.length - 1];



  return colorDomain;
};

Heatmap.prototype.setHeatmapRowsLabel = function(i) {
  var _self = this;

  return _self.WDAY_LABELS[i];
};

Heatmap.prototype.setColorScale = function(dimensionGroupsDayHour) {
  var _self = this;

  var colorScale = _self.default.colorScale.heatmap;
  var hasColorScaleRangeOverride = _self.options.colorScale && _self.options.colorScale.heatmap && _self.options.colorScale.heatmap.range;

  if (hasColorScaleRangeOverride)
    colorScale.range =  _self.options.colorScale.heatmap.range;


  colorScale.domain = _self.setColorDomain(dimensionGroupsDayHour);

  return d3.scale.linear()
      .domain(colorScale.domain)
      .range(colorScale.range);
};


Heatmap.prototype.setDaysPretransition = function(chart) {
  var _self = this;
  $(_self.ctx + _self.default.selector.barchartDays.svg).attr({width: 200, height: 120});
  $(_self.ctx + _self.default.selector.barchartDays.chartBody).attr('transform', 'translate(0,0)');
};

Heatmap.prototype.setHoursPretransition = function(chart) {
  var _self = this;
  // barChartHours render css overwrite
  $(_self.ctx + _self.default.selector.barchartHours.chartBody).attr('transform', 'translate(0, 10)');
  $(_self.ctx + _self.default.selector.barchartHours.svg).attr('height', 80);
}


Heatmap.prototype.processDataFormat = function(data) {
  //enforce value are processed as number
  data.forEach(function (d) {
    d.value = +d.value;
    d.day = +d.day;
    d.hour = +d.hour;
  });
};




Heatmap.prototype.render = function(ctx, data) {
  var _self = this;
  _self.ctx = ctx;

  // init chartGroup
  var chartGroupName = _self.options.chartGroupName ? _self.options.chartGroupName : "chartGroup";
  var heatmapChart = dc.heatMap(ctx + _self.default.selector.heatmap.container, chartGroupName);
  var barChartDays = dc.barChart(ctx + _self.default.selector.barchartDays.container, chartGroupName);
  var barChartHours = dc.barChart(ctx + _self.default.selector.barchartHours.container, chartGroupName);


  if (typeof data !== 'undefined' && data && data.constructor.toString().indexOf('Array') > -1) {
    _self.data = data;
    _self.processDataFormat(data);
  }


  // init crossfilter on data
  var ndx = _self.ndx = _self.options.crossfilter ? _self.options.crossfilter : crossfilter(data);


  // init dimensions filters
  var dimensions = _self.dimensions =  _self.getDimensions(ndx);
  var dimensionGroups = _self.getDimensionGroups(dimensions);



  // set heatmap color scale
  _self.scaleRange = _self.scaleRange || {};
  var heatColorMapping =_self.setColorScale(dimensionGroups.day_hour);


  var heatmapChartSize = {height: _self.default.heatmap.height, width: _self.default.heatmap.width};
  if (typeof _self.options.heatmap !== 'undefined') {
    heatmapChartSize.height |=  _self.options.heatmap.height;
    heatmapChartSize.width |= _self.options.heatmap.width;
  }

  // init heatmap d3
  heatmapChart
    .width(heatmapChartSize.width)
    .height(heatmapChartSize.height)
    .dimension(dimensions.day_hour)
    .group(dimensionGroups.day_hour)
    .keyAccessor((d) => { return +d.key[0]; })
    .valueAccessor((d) => { return +d.key[1]; })
    .colorAccessor((d) => { return +d.value.percentageGain; })
    .title(_self.getHeatmapTitle)
    .colors(heatColorMapping)
    .rowsLabel((i) => { return _self.setHeatmapRowsLabel(i); });

  heatmapChart.xBorderRadius(0);
  heatmapChart.yBorderRadius(0);




  // init heatmap legend d3
  var svg = d3.select(ctx + _self.default.selector.legendHeatmap.svg);

  svg.append("g")
    .attr("class", "legendLinear");

  var legendLinear = d3.legend.color()
    .shapeWidth(_self.options.legend.shapeWidth || 40)
    .shapeHeight(30)
    .shapePadding(0)
    .cells(10)
    .orient('horizontal')
    .scale(heatColorMapping)
    .labelFormat(_self.getLegendTitle);

  svg.select(".legendLinear")
    .call(legendLinear);

  // legend render css overwrite
  if (_self.options.legend.width) {
    $(ctx + _self.default.selector.legendHeatmap.svg).attr('width', _self.options.legend.width);
  }

  var daysChartSize = {height: _self.default.days.height, width: _self.default.days.width};
  if (_self.options.days) {
    daysChartSize.height |=  _self.options.days.height;
    daysChartSize.width |= _self.options.days.width;
  }

  // init barChartDays d3
  barChartDays
    .dimension(dimensions.day)
    .group(dimensionGroups.day)
    .height(daysChartSize.height)
    .width(daysChartSize.width)
    .y(d3.scale.linear().domain([0, 100]))
    .x(d3.scale.ordinal())
    .xUnits(dc.units.ordinal)
    .brushOn(false)
    .title(_self.getBarchartDayTitle)
    .on('pretransition', (chart) => {
      _self.setDaysPretransition(chart);
    })
    .elasticY(true);



  var hoursChartSize = {height: _self.default.hours.height, width: _self.default.hours.width};
  if (_self.options.hours) {
    hoursChartSize.height |=  _self.options.hours.height;
    hoursChartSize.width |= _self.options.hours.width;
  }
  // init barChartHours d3
  barChartHours
    .dimension(dimensions.hour)
    .group(dimensionGroups.hour)
    .height(hoursChartSize.height)
    .width(hoursChartSize.width)
    .x(d3.scale.ordinal())
    .xUnits(dc.units.ordinal)
    .y(d3.scale.linear().domain([0, 1]))
    .brushOn(false)
    .title(_self.getBarchartHourTitle)
    .on('pretransition', (chart) => {
      _self.setHoursPretransition(chart);
    })
    .elasticY(true);


  // overwrite to disable charts interactivity
  if (! _self.options.enable_controls) {
    $(ctx + _self.default.selector.compositeGroup.container).addClass('fixed-bars');

    var overrideControls = () => { };
    heatmapChart.boxOnClick = overrideControls;
    heatmapChart.xAxisOnClick = overrideControls;
    heatmapChart.yAxisOnClick = overrideControls;

    barChartDays.onClick = overrideControls;
    barChartHours.onClick = overrideControls;
  }


  // chartGroup render
  heatmapChart.render();
  barChartDays.render();
  barChartHours.render();


  return {
    crossfilter: ndx,
    chartGroupName: chartGroupName,
    legend: legendLinear,
    chartGroup: {
      heatmap: heatmapChart,
      hours: barChartHours,
      days: barChartDays
    },
    dimensions: dimensions,
    dimensionGroups: dimensionGroups,
    heatColorMapping: heatColorMapping,
    _self: _self
  }
};


export default Heatmap;



// WEBPACK FOOTER //
// ./src/modules/charts/heatmap.js